import React from "react";
import { Row, Col, Button, Space, Tag } from "antd";
import { Eye, EyeOff, Bell, Edit, CheckCircle, FileText, Search, Folder, XCircle } from "lucide-react";

const CalendarLegend = ({ visibleTypes, handleLegendClick, showAllEventTypes, hideAllEventTypes }) => {
  const legendItems = [
    { type: "visita", label: "Visitas", color: "", icon: null },
    { type: "solicitud", label: "Solicitudes", color: "blue", icon: <Bell size={12} /> },
    { type: "contrato", label: "Contratos", color: "purple", icon: <Edit size={12} /> },
    { type: "listo", label: "Marcado listo", color: "green", icon: <CheckCircle size={12} /> },
    { type: "emision", label: "Emitida", color: "gold", icon: <FileText size={12} /> },
    { type: "revision1", label: "Inicia Revisión", color: "cyan", icon: <Search size={12} /> },
    { type: "revision2", label: "Termina Revisión", color: "orange", icon: <Search size={12} /> },
    { type: "papeleria", label: "Entrega papelería", color: "lime", icon: <Folder size={12} /> },
    { type: "cancelacion", label: "Cancelación", color: "red", icon: <XCircle size={12} /> },
  ];

  return (
    <div className="calendar-legend">
      <Row gutter={16} align="middle" justify="space-between" style={{ marginBottom: 16 }}>
        <Col>
          <div className="filters-section">
            <Space size="small">
              <h3 className="filters-title">Filtros</h3>
              <Button type="text" size="small" icon={<Eye size={14} style={{ marginRight: 4 }} />} onClick={showAllEventTypes}>
                Mostrar todos
              </Button>
              <Button type="text" size="small" icon={<EyeOff size={14} style={{ marginRight: 4 }} />} onClick={hideAllEventTypes}>
                Ocultar todos
              </Button>
            </Space>
          </div>
        </Col>
      </Row>
      <Row gutter={16}>
        {legendItems.map((item) => (
          <Col key={item.type}>
            <div
              className={`legend-item ${!visibleTypes.includes(item.type) ? "legend-item-disabled" : ""}`}
              onClick={() => handleLegendClick(item.type)}
            >
              {item.type === "visita" ? (
                <>
                  <div className="legend-color legend-visita"></div>
                  <span>{item.label}</span>
                </>
              ) : (
                <Tag color={item.color} size="small" icon={item.icon} className={`calendar-tag calendar-tag-${item.type}`}>
                  {item.label}
                </Tag>
              )}
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default CalendarLegend;
